import { gql } from '@apollo/client';

export const GET_EMAILS_AND_ADDRESSES = gql`
  query GetEmailsAndAddresses($seasonId: String!) {
    season(id: $seasonId) {
      id
      emails {
        id
        subject
        job
        status
        recipientCount
        createdAt
        updatedAt
      }
    }
    myAccount {
      id
      name
      senderAddresses {
        id
        uid
        forwardTo {
          address
          isVerified
        }
      }
    }
  }
`;
